tinymce.Resource.add('tinymce.html-i18n.help-keynav.de',
'<h1>Grundlagen der Tastaturnavigation</h1>\n' +
  '\n' +
  '<dl>\n' +
  '  <dt>Fokus auf Menüleiste</dt>\n' +
  '  <dd>Windows oder Linux: ALT+F9</dd>\n' +
  '  <dd>macOS: &#x2325;F9</dd>\n' +
  '  <dt>Fokus auf Symbolleiste</dt>\n' +
  '  <dd>Windows oder Linux: ALT+F10</dd>\n' +
  '  <dd>macOS: &#x2325;F10</dd>\n' +
  '  <dt>Fokus auf Fußzeile</dt>\n' +
  '  <dd>Windows oder Linux: ALT+F11</dd>\n' +
  '  <dd>macOS: &#x2325;F11</dd>\n' +
  '  <dt>Benachrichtigung fokussieren</dt>\n' +
  '  <dd>Windows oder Linux: ALT+F12</dd>\n' +
  '  <dd>macOS: &#x2325;F12</dd>\n' +
  '  <dt>Fokus auf kontextbezogene Symbolleiste</dt>\n' +
  '  <dd>Windows, Linux oder macOS: STRG+F9</dd>\n' +
  '</dl>\n' +
  '\n' +
  '<p>Die Navigation beginnt beim ersten Benutzeroberflächenelement, welches hervorgehoben ist. Falls sich das erste Element im Pfad der Fußzeile befindet,\n' +
  '  ist es unterstrichen.</p>\n' +
  '\n' +
  '<h1>Zwischen Abschnitten der Benutzeroberfläche navigieren</h1>\n' +
  '\n' +
  '<p>Um von einem Abschnitt der Benutzeroberfläche zum nächsten zu wechseln, drücken Sie <strong>TAB</strong>.</p>\n' +
  '\n' +
  '<p>Um von einem Abschnitt der Benutzeroberfläche zum vorherigen zu wechseln, drücken Sie <strong>UMSCHALT+TAB</strong>.</p>\n' +
  '\n' +
  '<p>Die Abschnitte der Benutzeroberfläche haben folgende <strong>TAB</strong>-Reihenfolge:</p>\n' +
  '\n' +
  '<ol>\n' +
  '  <li>Menüleiste</li>\n' +
  '  <li>Einzelne Gruppen der Symbolleiste</li>\n' +
  '  <li>Randleiste</li>\n' +
  '  <li>Elementpfad in der Fußzeile</li>\n' +
  '  <li>Umschaltfläche „Wörter zählen“ in der Fußzeile</li>\n' +
  '  <li>Branding-Link in der Fußzeile</li>\n' +
  '  <li>Editor-Ziehpunkt zur Größenänderung in der Fußzeile</li>\n' +
  '</ol>\n' +
  '\n' +
  '<p>Falls ein Abschnitt der Benutzeroberflächen nicht vorhanden ist, wird er übersprungen.</p>\n' +
  '\n' +
  '<p>Wenn in der Fußzeile die Tastaturnavigation fokussiert ist und keine Randleiste angezeigt wird, wechselt der Fokus durch Drücken von <strong>UMSCHALT+TAB</strong>\n' +
  '  zur ersten Gruppe der Symbolleiste, nicht zur letzten.</p>\n' +
  '\n' +
  '<h1>Innerhalb von Abschnitten der Benutzeroberfläche navigieren</h1>\n' +
  '\n' +
  '<p>Um von einem Element der Benutzeroberfläche zum nächsten zu wechseln, drücken Sie die entsprechende <strong>Pfeiltaste</strong>.</p>\n' +
  '\n' +
  '<p>Die Pfeiltasten <strong>Links</strong> und <strong>Rechts</strong></p>\n' +
  '\n' +
  '<ul>\n' +
  '  <li>wechseln zwischen Menüs in der Menüleiste.</li>\n' +
  '  <li>öffnen das Untermenü eines Menüs.</li>\n' +
  '  <li>wechseln zwischen Schaltflächen in einer Gruppe der Symbolleiste.</li>\n' +
  '  <li>wechseln zwischen Elementen im Elementpfad der Fußzeile.</li>\n' +
  '</ul>\n' +
  '\n' +
  '<p>Die Pfeiltasten <strong>Abwärts</strong> und <strong>Aufwärts</strong></p>\n' +
  '\n' +
  '<ul>\n' +
  '  <li>wechseln zwischen Menüelementen in einem Menü.</li>\n' +
  '  <li>wechseln zwischen Elementen in einem Popupmenü der Symbolleiste.</li>\n' +
  '</ul>\n' +
  '\n' +
  '<p>Die <strong>Pfeiltasten</strong> rotieren innerhalb des fokussierten Abschnitts der Benutzeroberfläche.</p>\n' +
  '\n' +
  '<p>Um ein geöffnetes Menü, ein geöffnetes Untermenü oder ein geöffnetes Popupmenü zu schließen, drücken Sie die <strong>ESC</strong>-Taste.</p>\n' +
  '\n' +
  '<p>Wenn sich der aktuelle Fokus ganz oben in einem bestimmten Abschnitt der Benutzeroberfläche befindet, wird durch Drücken der <strong>ESC</strong>-Taste auch\n' +
  '  die Tastaturnavigation beendet.</p>\n' +
  '\n' +
  '<h1>Ein Menüelement oder eine Symbolleistenschaltfläche ausführen</h1>\n' +
  '\n' +
  '<p>Wenn das gewünschte Menüelement oder die gewünschte Symbolleistenschaltfläche hervorgehoben ist, drücken Sie <strong>Zurück</strong>, <strong>Eingabe</strong>\n' +
  '  oder die <strong>Leertaste</strong>, um das Element auszuführen.</p>\n' +
  '\n' +
  '<h1>In Dialogfeldern ohne Registerkarten navigieren</h1>\n' +
  '\n' +
  '<p>In Dialogfeldern ohne Registerkarten ist beim Öffnen eines Dialogfelds die erste interaktive Komponente fokussiert.</p>\n' +
  '\n' +
  '<p>Navigieren Sie zwischen den interaktiven Komponenten eines Dialogfelds, indem Sie <strong>TAB</strong> oder <strong>UMSCHALT+TAB</strong> drücken.</p>\n' +
  '\n' +
  '<h1>In Dialogfeldern mit Registerkarten navigieren</h1>\n' +
  '\n' +
  '<p>In Dialogfeldern mit Registerkarten ist beim Öffnen eines Dialogfelds die erste Schaltfläche eines Registerkartenmenüs fokussiert.</p>\n' +
  '\n' +
  '<p>Navigieren Sie zwischen den interaktiven Komponenten auf dieser Registerkarte des Dialogfelds, indem Sie <strong>TAB</strong> oder\n' +
  '  <strong>UMSCHALT+TAB</strong> drücken.</p>\n' +
  '\n' +
  '<p>Wechseln Sie zu einer anderen Registerkarte des Dialogfelds, indem Sie den Fokus auf das Registerkartenmenü legen und dann die entsprechende <strong>Pfeiltaste</strong>\n' +
  '  drücken, um durch die verfügbaren Registerkarten zu rotieren.</p>\n');